var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "setting-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6,3A3,3,0,1,1,3,0,3,3,0,0,1,6,3Z",
    transform: "translate(11 11)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,12.505V10.372a2.3,2.3,0,0,1,2.28-2.3c2.172,0,3.06-1.551,1.968-3.454a2.314,2.314,0,0,1,.84-3.139L7.163.277A1.992,1.992,0,0,1,9.9,1l.132.23c1.08,1.9,2.856,1.9,3.948,0L14.111,1A1.992,1.992,0,0,1,16.847.277l2.076,1.2a2.314,2.314,0,0,1,.84,3.139c-1.092,1.9-.2,3.454,1.968,3.454a2.3,2.3,0,0,1,2.28,2.3v2.133a2.3,2.3,0,0,1-2.28,2.3c-2.172,0-3.06,1.551-1.968,3.454a2.311,2.311,0,0,1-.84,3.139l-2.076,1.2a1.992,1.992,0,0,1-2.736-.727l-.132-.23c-1.08-1.9-2.856-1.9-3.948,0l-.132.23a1.992,1.992,0,0,1-2.736.727L5.088,21.4a2.314,2.314,0,0,1-.84-3.139c1.092-1.9.2-3.454-1.968-3.454A2.3,2.3,0,0,1,0,12.505Z",
    transform: "translate(2 2.561)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsWhite);
export default __webpack_public_path__ + "static/media/settingsWhite.90e55d56df73fe62d2f5a4fed7a48641.svg";
export { ForwardRef as ReactComponent };